module.exports = __webpack_public_path__ + "img/loading.c139e12e.svg";